import React from "react";
import styled from "styled-components";
import LoginButton from "../heroAreaButtons/loginButton";
import NewRegistryButton from "../heroAreaButtons/newRegistryButton";
import SignUpButton from "../heroAreaButtons/signUpButton";
import {NavigationURLs} from "../../functions/NavigationFunctions";

const MobileHeroArea = () => {
    return (
        <StyledMobileHeroArea>
            <NewRegistryButton/>
            <SignUpButton url={NavigationURLs.register} textColor={true} backgroundColor={'#D2147D'}/>
            <LoginButton url={NavigationURLs.login}/>
        </StyledMobileHeroArea>
    );
};

const StyledMobileHeroArea = styled.div`
  position: relative;
  padding-bottom: 65px;
  width: 100%;
`;

export default MobileHeroArea;
